<template>
  <!-- <div style="margin-top: 70px"> -->
  <div>
    <v-container class="mt-5">
      <v-layout text-center wrap>
        <v-flex xs12>
          <!-- <v-card style="border-radius: 26px" outlined tile rounded class="ma-auto grey darken-3">  -->
          <v-card style=" width: auto" flat rounded class="ma-auto">
            <v-card-text class="display-1 font-weight-light black--text"
              >MATTERS</v-card-text
            >
            <!-- <v-layout row> -->
            <v-form @submit.prevent="goToMatterFromSearch">
              <v-autocomplete
                label="SEARCH MATTERS"
                outlined
                rounded
                clearable
                solo
                autofocus
                class="ma-auto"
                append-icon="mdi-magnify"
                :items="matters"
                item-text="caseName"
                item-value="matterSlug"
                v-model="slug"
                style="max-width: 500px"
              ></v-autocomplete>
            </v-form>

            <!-- <v-btn class="green" @click="goToMatterFromSearch">GO</v-btn> -->
            <!-- </v-layout> -->
            <v-card
              flat
              filled
              style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
        "
              class="ma-auto"
            >
              <v-list
                class="ma-auto"
                style="border-radius: 26px; overflow: scroll"
                height="60vh"
              >
                <v-list-item
                  v-for="(matter, index) in matters"
                  :key="index"
                  class="ma-2"
                >
                  <v-flex>
                    <v-card
                      @click="goToMatter(matter.matterSlug)"
                      class="ma-3"
                      flat
                      outlined
                      style="border-radius: 26px; border: 1px solid #18CAE6"
                    >
                      <v-list-item-content>
                        <v-layout row wrap>
                          <v-col>
                            <v-list-item-title
                              class="ma-auto font-weight-bold"
                              style="min-width: 500px"
                            >
                              {{ matter.caseName }}
                            </v-list-item-title>
                          </v-col>
                          <v-col></v-col>
                          <v-col>
                            <v-list-item-subtitle class="ma-auto">
                              DATE OF LOSS:
                              {{ matter.dateOfLoss }}
                            </v-list-item-subtitle>
                          </v-col>
                          <v-col></v-col>
                          <v-col>
                            <v-list-item-subtitle class="ma-auto">
                              FORM COUNT:
                              {{ matter.formCount }}
                            </v-list-item-subtitle>
                          </v-col>
                          <v-col></v-col>
                          <!-- <v-spacer></v-spacer>

                        <v-spacer></v-spacer>
                        <div>
                          <v-btn small rounded dark>
                            <v-icon color="#a07800">mdi-pencil</v-icon>
                          </v-btn>
                        </div> -->
                        </v-layout>
                      </v-list-item-content>
                    </v-card>
                  </v-flex>
                </v-list-item>
              </v-list>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
/**
 *
 *
 * shows a list of matters that is searchable
 *
 */
export default {
  name: "Matters",
  data: () => ({
    slug: null
  }),
  computed: {
    matters() {
      return this.$store.getters.matters;
    },
    user() {
      return this.$store.getters.user;
    },
    firm() {
      return this.$store.getters.firm;
    }
  },
  methods: {
    goToMatter(id) {
      console.log(id);
      this.$router.push({ name: "Matter", params: { id } });
    },
    goToMatterFromSearch() {
      console.log(this.slug);
      let id = this.slug;
      this.$router.push({ name: "Matter", params: { id } });
      this.slug = null;
    }
  },
  created() {
    console.log("Matters created");
    // let matters = this.$store.getters.matters;
    console.log("matters from created at matters", this.matters);
    console.log("user from created at matters", this.user);
    if (this.user) {
      this.$store.dispatch("getFirm", this.user.firmSlug);
    }
    console.log("firm from created at matters", this.firm);
    window.document.title = `TAPLAW`;
  }
};
</script>

<style scoped></style>
